// Dragon Radar settings — adjust alignment / timings here
export const RADAR_IMAGE = 'https://customer-assets-rejwkqb3.emergentagent.net/job_dragon-sphere-tv/artifacts/b2b6beb90ef66d53_260199.png';

// Green screen circle inside the image, as % of image width/height (image is square)
export const SCREEN = { cx: 49, cy: 52.75, r: 35.5 };
// Top push-button (cycles zoom like the anime radar)
export const KNOB = { cx: 48.5, cy: 8.5, r: 7 };

export const ZOOMS = [
  { id: 'wide', label: 'WIDE', factor: 0.6 },
  { id: 'standard', label: 'STD', factor: 1 },
  { id: 'close', label: 'CLOSE', factor: 1.6 },
];
export const SWEEP_IDLE_S = 4;
export const SWEEP_ACTIVE_S = 1.6;
export const ACTIVE_SCAN_MS = 4000;
export const SCAN_POLL_MS = 15000;
export const PEEK_MS = 7000;

// Drop sound files here to enable them (muted by default)
export const SOUND_URLS = {
  beep: '/sounds/radar-beep.mp3',
  detect: '/sounds/radar-beep.mp3',
  button: '',
  zoom: '',
  mode: '',
  power: '',
};
export const SOUND_VOLUME = 0.35;

// Hot-cold beep: time between beeps and pitch by proximity to the Dragon Ball page
export const BEEP_MS = { far: 2400, near: 1100, here: 380 };
export const BEEP_PITCH = { far: 0.9, near: 1, here: 1.15 };
export const BEEP_POLL_MS = 10000;
